import sileo from 'sileo';

const EmailSubscription = new sileo.Model('email_subscription', 'unsubscribe-email');

const actions = {
    unsubscribeEmail(context, data) {
        const form = new FormData();
        form.append('is_subscribed', data.isSubscribed);
        return EmailSubscription.objects.update({ token: data.token }, form);
    },
};

export default {
    namespaced: true,
    actions,
};
